import { getHotMovies } from '@/mocks/movies';
import MovieCard from '@/components/base/MovieCard';
import { Link } from 'react-router-dom';

export default function FeaturedMovies() {
  const hotMovies = getHotMovies(8);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 font-bold mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500">大家都在看的高分佳作</p>
          </div>
          <Link
            to="/category/movie"
            className="flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            更多推荐
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {hotMovies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="bg-background-100 rounded-xl p-5 flex items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-xl flex-shrink-0">
              <i className="ri-4k-line text-2xl text-primary-500"></i>
            </div>
            <div>
              <p className="text-sm font-medium text-foreground-950">蓝光画质</p>
              <p className="text-xs text-foreground-500">4K超清视觉享受</p>
            </div>
          </div>
          <div className="bg-background-100 rounded-xl p-5 flex items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-xl flex-shrink-0">
              <i className="ri-flashlight-line text-2xl text-accent-600"></i>
            </div>
            <div>
              <p className="text-sm font-medium text-foreground-950">极速播放</p>
              <p className="text-xs text-foreground-500">点开即播不缓冲</p>
            </div>
          </div>
          <div className="bg-background-100 rounded-xl p-5 flex items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center bg-secondary-100 rounded-xl flex-shrink-0">
              <i className="ri-refresh-line text-2xl text-secondary-500"></i>
            </div>
            <div>
              <p className="text-sm font-medium text-foreground-950">每日更新</p>
              <p className="text-xs text-foreground-500">热门影片及时上架</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}